var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_1_",
    "data-name": "instagram (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M218.484,212.742A5.742,5.742,0,1,1,212.742,207,5.742,5.742,0,0,1,218.484,212.742Zm0,0",
    transform: "translate(-182.742 -182.742)",
    fill: "#90c900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M163.037,139.451a5.7,5.7,0,0,0-3.269-3.269,9.531,9.531,0,0,0-3.2-.593c-1.817-.083-2.362-.1-6.961-.1s-5.145.017-6.961.1a9.537,9.537,0,0,0-3.2.593,5.707,5.707,0,0,0-3.27,3.269,9.534,9.534,0,0,0-.593,3.2c-.083,1.816-.1,2.361-.1,6.961s.018,5.144.1,6.961a9.531,9.531,0,0,0,.593,3.2,5.7,5.7,0,0,0,3.269,3.269,9.519,9.519,0,0,0,3.2.593c1.816.083,2.361.1,6.961.1s5.145-.017,6.961-.1a9.519,9.519,0,0,0,3.2-.593,5.7,5.7,0,0,0,3.269-3.269,9.54,9.54,0,0,0,.593-3.2c.083-1.817.1-2.362.1-6.961s-.017-5.145-.1-6.961A9.519,9.519,0,0,0,163.037,139.451Zm-13.429,19.005a8.846,8.846,0,1,1,8.846-8.846A8.846,8.846,0,0,1,149.608,158.457Zm9.2-15.974a2.067,2.067,0,1,1,2.067-2.067A2.067,2.067,0,0,1,158.8,142.483Zm0,0",
    transform: "translate(-119.608 -119.611)",
    fill: "#90c900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M30,0A30,30,0,1,0,60,30,30,30,0,0,0,30,0ZM47.123,37.1a12.639,12.639,0,0,1-.8,4.182,8.808,8.808,0,0,1-5.038,5.038,12.647,12.647,0,0,1-4.181.8c-1.837.084-2.424.1-7.1.1s-5.265-.02-7.1-.1a12.648,12.648,0,0,1-4.181-.8,8.808,8.808,0,0,1-5.038-5.038,12.636,12.636,0,0,1-.8-4.181c-.085-1.837-.1-2.424-.1-7.1s.02-5.265.1-7.1a12.64,12.64,0,0,1,.8-4.182,8.814,8.814,0,0,1,5.039-5.038,12.651,12.651,0,0,1,4.182-.8c1.837-.084,2.424-.1,7.1-.1s5.265.02,7.1.1a12.653,12.653,0,0,1,4.182.8,8.811,8.811,0,0,1,5.038,5.039,12.637,12.637,0,0,1,.8,4.182c.084,1.837.1,2.424.1,7.1S47.207,35.265,47.123,37.1Zm0,0",
    fill: "#90c900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLight);
export default __webpack_public_path__ + "static/media/instagramLight.f65d47afe9275a004b74aab90e95b6c3.svg";
export { ForwardRef as ReactComponent };